export const UPDATE_CHAT_CONVERSATION_REQUEST = 'UPDATE_CHAT_CONVERSATION_REQUEST';

export const updateChatConversationRequest = (id, formData) => ({
    type: UPDATE_CHAT_CONVERSATION_REQUEST,
    payload: {
        id,
        formData
    },
});
